import React, { createContext, useState, Dispatch, SetStateAction } from 'react';
import { EMERGENT, EXEMPLARS_NAV_LIST } from '../constants';
import { getDefaultStage, setDefaultStage as setDefaultStageToStorage } from '../utils/storage';

interface IAuthContext {
  auth: boolean;
  email: string;
  defaultStage: string;
  access: string;
  trialDaysLeft: string | number;
  isTrialAccess: boolean;
  setAuth: Dispatch<SetStateAction<boolean>>;
  setEmail: Dispatch<SetStateAction<string>>;
  setDefaultStage: Dispatch<string>;
  setAccess: Dispatch<string>;
  setTrialDaysLeft: Dispatch<string | number>;
}

export const DEFAULT_STAGE = EMERGENT;

const storageAuth = !!localStorage.getItem('token');
const email = localStorage.getItem('email') || '';
const defaultStage = getDefaultStage() || DEFAULT_STAGE;
const access = localStorage.getItem('access') || 'COLLECTION';
const trialDaysLeft = localStorage.getItem('trialDaysLeft') || 0;

const initialState = {
  auth: storageAuth,
  email: email,
  defaultStage: defaultStage,
  access: access,
  trialDaysLeft: trialDaysLeft,
  isTrialAccess: false,
  setAuth: (): void => {
    console.error('Function should be provided through the context value');
  },
  setEmail: (): void => {
    console.error('Function should be provided through the context value');
  },
  setDefaultStage: (): void => {
    console.error('Function should be provided through the context value');
  },
  setAccess: (): void => {
    console.error('Function should be provided through the context value');
  },
  setTrialDaysLeft: (): void => {
    console.error('Function should be provided through the context value');
  },
};

const AuthContext = createContext<IAuthContext>(initialState);

export const AuthProvider: React.FC = ({ children }) => {
  const [auth, setAuth] = useState<boolean>(initialState.auth);
  const [email, setEmail] = useState<string>(initialState.email);
  const [defaultStage, setStage] = useState<string>(initialState.defaultStage);
  const [access, setAccess] = useState<string>(initialState.access);
  const [trialDaysLeft, setTrialDaysLeft] = useState<string | number>(initialState.trialDaysLeft);

  const isTrialAccess = ['TRIAL', 'LONG_TERM_TRIAL'].includes(access);

  const setDefaultStage = (stage: string) => {
    const newDefaultStage = EXEMPLARS_NAV_LIST.includes(stage) ? stage : DEFAULT_STAGE;
    setStage(newDefaultStage);
    setDefaultStageToStorage(newDefaultStage);
  };

  return (
    <AuthContext.Provider
      value={{
        auth,
        setAuth,
        email,
        setEmail,
        defaultStage,
        setDefaultStage,
        access,
        setAccess,
        trialDaysLeft,
        setTrialDaysLeft,
        isTrialAccess,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
